import axios from "axios";
import {getAppLang, getProperty, getUserToken} from "../../../../utils";
import {WEB_CHANNEX_STATUS, WEB_CHANNEX_CONNECT} from "../../../../constants/api.constants";
import {webChannexConstants} from "../../../../constants/Web/webChannex.constants";

const requestHeaders = () => ({
    'Content-Type': 'application/json',
    'authToken': getUserToken(),
    'language': getAppLang(),
});

const body = () => ({params: {property_id: getProperty()}});

/**
 * Tesisin Channex baglanti durumunu doner.
 * Beklenen: data: { connected: bool, channel_manager_property_id, property_title, room_count, last_sync_at }
 * Kaynak tablo: channel_manager_property_mapping (channel_manager_property_id dolu ise bagli).
 */
export function getChannexStatus() {
    return dispatch => {
        dispatch({
            type: 'WEB_CHANNEX_STATUS',
            payload: axios.post(WEB_CHANNEX_STATUS, body(), {headers: requestHeaders()})
                .then(response => response.data)
        })
    }
}

/**
 * Channex baglantisini kurar/yeniler.
 * Kullanicidan girdi alinmaz: tesis bilgileri panelde zaten kayitli oldugu icin
 * servis Channex tarafinda property olusturur ve eslesmeyi kaydeder.
 */
export function connectChannex() {
    return dispatch => {
        dispatch({
            type: 'WEB_CHANNEX_CONNECT',
            payload: axios.post(WEB_CHANNEX_CONNECT, body(), {headers: requestHeaders()})
                .then(response => response.data)
        })
    }
}

export function clearWebChannex() {
    return dispatch => {
        dispatch({type: webChannexConstants.WEB_CHANNEX_CLEAR});
    }
}
